import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { SvgIconComponent, SvgIcons } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { Confirmation, ConfirmationService, MessageService } from 'primeng/api';
import type { Button } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { skip } from 'rxjs';

import { QueryParamsService } from './services/queryparams.service';
import { cast } from './utils/cast';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, ConfirmDialogModule, TranslateModule, SvgIconComponent, ToastModule, CommonModule],
  providers: [ConfirmationService, MessageService],
})
export class AppComponent {
  title = 'back-office';
  readonly qpSignals = inject(QueryParamsService);
  readonly router = inject(Router);
  readonly destroyRef = inject(DestroyRef);

  constructor() {
    const sub = toObservable(this.qpSignals.queryParams)
      .pipe(skip(1))
      .subscribe((queryParams) => {
        void this.router.navigate([], {
          queryParams,
          replaceUrl: true,
          queryParamsHandling: 'merge',
        });
      });
    this.destroyRef.onDestroy(() => sub.unsubscribe());
  }

  // eslint-disable-next-line class-methods-use-this
  getToastIcon(severity: string) {
    switch (severity) {
      case 'error':
        return 'alert-circle';
      case 'success':
        return 'check-circle';
      default:
        return 'warning';
    }
  }

  castAsConfirmation = cast<Confirmation & { acceptButtonSeverity: Button['severity']; acceptIcon: SvgIcons }>;
}
